/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Media_Import_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Error - Media import failed" |
*
* @param {Load_Project_File_Media_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_media_import_failed_toast = /** @type {((inputs?: Load_Project_File_Media_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Media_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur - Echec de l'importation du media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler – Medienimport fehlgeschlagen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore - Importazione del supporto non riuscita")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка - Не удалось импортировать медиафайлы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error: Error en la importación de medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误 - 媒体导入失败")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラー - メディアのインポートに失敗しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटि - मीडिया आयात विफल रहा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro - Falha na importação de mídia")
	return /** @type {LocalizedString} */ ("Error - Media import failed")
});